import { useState, useEffect, useCallback } from 'react';
import { tradesAPI } from '../services/api';

export default function useMarketStatus() {
  const [status, setStatus] = useState({
    isLive: false,
    matchLabel: null,
    lockedAt: null,
    lastChecked: null,
    tradingOpen: true,
  });

  const fetch = useCallback(async () => {
    try {
      const r = await tradesAPI.marketStatus();
      setStatus(r.data);
    } catch {
      // silently ignore — don't crash UI on network error
    }
  }, []);

  useEffect(() => {
    fetch();
    // Poll every 30 seconds so UI updates promptly when a match starts/ends
    const interval = setInterval(fetch, 30000);
    return () => clearInterval(interval);
  }, [fetch]);

  return { status, refresh: fetch };
}
